import { render, staticRenderFns } from "./RegMalariaEdit.vue?vue&type=template&id=01d09345&scoped=true"
import script from "./RegMalariaEdit.vue?vue&type=script&lang=js"
export * from "./RegMalariaEdit.vue?vue&type=script&lang=js"
import style0 from "./RegMalariaEdit.vue?vue&type=style&index=0&id=01d09345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d09345",
  null
  
)

export default component.exports